import React from 'react';
import { FiXCircle } from 'react-icons/fi';
import UserDetailsView from './UserDetailsView';
import UserContractStatusForm from './UserContractStatusForm';

/**
 * Modal for viewing or editing a user.
 * View mode: read-only details + account actions.
 * Edit mode: same details + contract status form (reusable for other edit fields later).
 */
const UserModal = ({
  user,
  mode,
  onClose,
  onStatusChange,
  onContractStatusSave,
  contractStatusSaving,
}) => {
  if (!user) return null;

  const isEdit = mode === 'edit';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-[95vw] sm:max-w-4xl lg:max-w-6xl max-h-[90vh] overflow-y-auto mx-4">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center sticky top-0 bg-white z-10">
          <h3 className="text-lg font-medium text-gray-900">
            {isEdit ? 'Edit User' : 'User Details'}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
            aria-label="Close"
          >
            <FiXCircle className="w-6 h-6" />
          </button>
        </div>

        <div className="px-6 py-4">
          <UserDetailsView
            user={user}
            onStatusChange={onStatusChange}
            showAccountActions
          />

          {isEdit && onContractStatusSave && (
            <div className="mt-6">
              <UserContractStatusForm
                user={user}
                onSave={onContractStatusSave}
                onCancel={onClose}
                saving={contractStatusSaving}
              />
            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
